import {env} from '../../../environment'

interface FetchErrorOptions {
  data: string
}

const fetchError = (options: FetchErrorOptions) => {
  const form = new FormData()
  form.append('data', options.data)

  const url = env.getServiceHost() + 'app/error'
  return fetch(url, { method: 'post', body: form }).then(response =>
    response.json(),
  )
}

export default fetchError
